import { Link } from "react-router-dom";
import Slider from "react-slick";

import bg from "../assets/bg.png";
import img1 from "../assets/asset_1.jpg";
import img2 from "../assets/asset_2.jpg";
import img3 from "../assets/asset_3.jpg";
import img4 from "../assets/asset_4.jpg";
import img5 from "../assets/asset_5.jpg";
import img6 from "../assets/asset_6.jpg";
import img7 from "../assets/asset_7.jpg";
import img8 from "../assets/asset_8.jpg";
import img9 from "../assets/asset_9.jpg";
import img10 from "../assets/asset_10.jpg";
import img11 from "../assets/asset_11.jpg";
import img12 from "../assets/asset_12.jpg";

import useWindowDimensions from "../hooks/useWindowDimensions";

const Home = () => {
  const { width } = useWindowDimensions();

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,

    slidesToShow: 3,
    fade: false,
    slidesToScroll: 1,
    rtl: false,
    initialSlide: 1,
    autoplay: true,
    autoplaySpeed: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      id="home"
      className="min-vh-100 d-flex flex-column justify-content-center align-items-center"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        zIndex: 1,
      }}
    >
      <div
        className="container"
        style={{
          marginTop: width < 992 && 100,
        }}
      >
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-6 col-md-6 col-12">
            <h1
              className="primary-h"
              data-aos="fade-up"
              data-aos-duration="700"
              style={{
                textAlign: width < 992 && "center",
                margin: width < 992 && "auto",
              }}
            >
              Laser
              <br />
              Octopus
              <br />
              Club
            </h1>
            <div
              className="d-flex gap-3"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay="100"
              style={{
                justifyContent: width < 992 && "center",
              }}
            >
              <Link to="/mint">
                <button className="primary-btn my-3">Let's Mint!</button>
              </Link>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-12">
            <div
              className="home-gallery-wrapper"
              data-aos="fade-up"
              data-aos-duration="700"
            >
              <ul className="home-gallery">
                <Slider {...settings}>
                  <li>
                    <img alt="" src={img1} />
                  </li>
                  <li>
                    <img alt="" src={img2} />
                  </li>
                  <li>
                    <img alt="" src={img3} />
                  </li>
                  <li>
                    <img alt="" src={img4} />
                  </li>
                  <li>
                    <img alt="" src={img5} />
                  </li>
                  <li>
                    <img alt="" src={img6} />
                  </li>
                </Slider>
              </ul>
              <ul className="home-gallery">
                <Slider {...settings} rtl={true}>
                  <li>
                    <img alt="" src={img7} />
                  </li>
                  <li>
                    <img alt="" src={img8} />
                  </li>
                  <li>
                    <img alt="" src={img9} />
                  </li>
                  <li>
                    <img alt="" src={img10} />
                  </li>
                  <li>
                    <img alt="" src={img11} />
                  </li>
                  <li>
                    <img alt="" src={img12} />
                  </li>
                </Slider>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
